var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.115 15.77C2.66833 15.77 2.28733 15.6127 1.972 15.298C1.65733 14.9833 1.5 14.6023 1.5 14.155V1.77H0.5V0.77H4.5V0H10.5V0.77H14.5V1.77H13.5V14.155C13.5 14.615 13.346 14.999 13.038 15.307C12.7293 15.6157 12.345 15.77 11.885 15.77H3.115ZM12.5 1.77H2.5V14.155C2.5 14.3343 2.55767 14.4817 2.673 14.597C2.78833 14.7123 2.93567 14.77 3.115 14.77H11.885C12.0383 14.77 12.1793 14.706 12.308 14.578C12.436 14.4493 12.5 14.3083 12.5 14.155V1.77ZM5.308 12.77H6.308V3.77H5.308V12.77ZM8.692 12.77H9.692V3.77H8.692V12.77Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.9cb14e4989017d60d3342e22c1804abd.svg";
export { ForwardRef as ReactComponent };